/* eslint-disable react/default-props-match-prop-types */
import React from 'react';
import Transition from 'react-transition-group/Transition';
import PropTypes from 'prop-types';
import CloseIcon from '../../icons/cancel.svg';

import styles from './modal.module.scss';
import Button from '../button/button';
import FormattedMessageWithClass from '../formattedMessageWithClass';

const Modal = ({ onClose, children, showIn, width, minHeight, contentStyles,
  disableOutsideClick, closeIcon, title, titleId = ' ', btnList = [], btnPosition = 'end' }) => {
  const onOverlayClick = () => {
    if (disableOutsideClick) return;
    onClose();
  };

  const transitionStyles = {
    entering: { opacity: 0 },
    entered: { opacity: 1 }
  };

  return (
    <Transition in={showIn} timeout={0} unmountOnExit>
      {state => (
        <div className={styles.modal} style={transitionStyles[state]}>
          <div className={styles.overlay} tabIndex="0"
            onClick={onOverlayClick} onKeyPress={onOverlayClick} role="button"
          />
          <div
            className={styles.content}
            style={{ width: `${width}`, minHeight: `${minHeight}`, ...contentStyles }}
          >
            {title && (
              <div className={styles.modalHeader}>
                <h3 className={styles.title}>
                  <FormattedMessageWithClass id={titleId} defaultMessage={title} />
                </h3>
                {closeIcon && (
                  <div role="button" tabIndex="0"
                    onClick={onClose} onKeyDown={onClose}
                    className={styles.closeBtn}
                  >
                    <img src={CloseIcon} alt="closeIcon" width={15} height={15} />
                  </div>
                )}
              </div>
            )}
            {!title && closeIcon
             && <div className={styles.closeIcon} onClick={() => onClose()} role="button" tabIndex={0}
                onKeyPress={() => onClose()}>
                  <img src={CloseIcon} alt="closeIcon" />
                </div>}
            {children}
            {btnList && btnList?.length > 0 && (
              <div className={`${styles.modalFooter} ${styles[btnPosition]}`}>
                {btnList.map(btn => (
                  <Button
                    onClick={() => btn.onClick()}
                    translationID={btn.id}
                    defaultText={btn.label}
                    action={btn.action || 'primary'}
                    disabled={btn.disabled || false}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </Transition>
  );
};

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  showIn: PropTypes.bool,
  width: PropTypes.string,
  minHeight: PropTypes.string,
  contentStyles: PropTypes.shape({})
};


Modal.defaultProps = {
  showIn: false,
  width: '50%',
  minHeight: '45%',
  contentStyles: {},
  disableOutsideClick: false
};

export default Modal;
